let isFormLoaded = false,
    buttonStateInterval,
    formStateInterval;

class KlaviyoFormValidator {
    constructor() {
        this.checkButtonState = this.checkButtonState.bind(this);
        this.formSelect = document.querySelector('.Form__Select');

        if (this.formSelect) {
            this.selectHideDropdown = this.selectHideDropdown.bind(this);
            this.selectShowDropdown = this.selectShowDropdown.bind(this);
        }
    }

    selectHideDropdown(e) {
        if (!this.formSelect.contains(e.target)) {
            this.formSelect.classList.remove('selected');
        }
    }

    selectShowDropdown(e) {
        const input = this.formSelect.querySelector('input');
        let selected = null;

        if (e.target.tagName === "LI") {
            selected = e.target.textContent;
            input.value = selected;
            this.formSelect.classList.remove('selected');
        } else {
            this.formSelect.classList.add('selected');
        }
    }

    isValidEmail(email) {
        return !!String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    checkButtonState() {
        const klaviyoForm = document.querySelector('.Klaviyo__Form form.klaviyo-form');

        if (!klaviyoForm) {
            return;
        }

        const inputs = klaviyoForm.querySelectorAll('input:not([type="checkbox"]):not([type="submit"])');
        const submitButton = document.querySelector('.Klaviyo__Form form.klaviyo-form button:not(input + button)')
        let submitButtonDisabled = false;

        if (!klaviyoForm.classList.contains('isLoaded')) {
            klaviyoForm.classList.add('isLoaded');
        }

        for (let i = 0; i < inputs.length; i++) {
            const isInputValid = inputs[i].type === 'email' ? this.isValidEmail(inputs[i].value) : !!inputs[i].value;

            if (!isInputValid) {
                submitButtonDisabled = true;
                break;
            }
        }

        if (submitButtonDisabled) {
            submitButton.setAttribute('disabled', 'disabled');
        } else {
            submitButton?.removeAttribute('disabled');
        }
    }

    checkFormState() {
        const submitButton = document.querySelector('.Klaviyo__Form form.klaviyo-form button:not(input + button)')

        if (!submitButton) {
            if (isFormLoaded) {
                document.querySelector('.remove-on-submit')?.remove();
                clearInterval(formStateInterval);
                clearInterval(buttonStateInterval);
            }
        } else if (!isFormLoaded) {
            isFormLoaded = true;
        }
    }

    init() {
        buttonStateInterval = setInterval(this.checkButtonState, 100);
        formStateInterval = setInterval(this.checkFormState, 100);
        if (this.formSelect) {
            document.addEventListener('click', this.selectHideDropdown);
            this.formSelect.addEventListener('click', this.selectShowDropdown);
        }
    }
}

const klaviyoFormValidator = new KlaviyoFormValidator();
const KlaviyoFormValidatorInterval = setInterval(() => {
    const formAvailable = document.querySelector('.Klaviyo__Form form.klaviyo-form input');

    if (formAvailable) {
        klaviyoFormValidator.init();
        clearInterval(KlaviyoFormValidatorInterval);
    }
}, 100);